module.exports = __webpack_public_path__ + "img/黃槿謙德_四方連續_彩稿.6824a1e0.png";